import { render, staticRenderFns } from "./botonReclamos.vue?vue&type=template&id=4ca95785&"
import script from "./botonReclamos.vue?vue&type=script&lang=js&"
export * from "./botonReclamos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports